import { CardContent, Card, CardHeader, CardTitle } from '../ui/card';
import { clubApi } from '@repo/api-client';
import { toast } from 'sonner';
import { getDiffValues } from '@/lib/utils';
import { useCurrentClub } from '@/hooks/use-current-club';
import { useForm } from '@repo/ui/hooks/use-form';
import { Input } from '@repo/ui/components/form/input';
import { Button } from '@repo/ui/components/button';
import { Select } from '@repo/ui/components/form/select';
import { countries } from '@repo/ui/lib/countries';
import { Club } from '@repo/shared-types';

export function Location() {
  const club = useCurrentClub();
  const { ref, errors, values } = useForm({
    initialValues: club,
    onSubmit: async () => {
      const diffValues = getDiffValues(club, values);
      await clubApi.update(club.id, diffValues as Partial<Club>);
      toast.success('Ubicación actualizada correctamente');
    },
  });
  return (
    <Card>
      <CardHeader>
        <CardTitle>Ubicación</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <form ref={ref} className="flex flex-col gap-4">
          <Input
            label="Dirección"
            name="address"
            errors={errors}
            required
            minLength={3}
            maxLength={255}
            placeholder="Calle Principal 123"
            type="text"
          />
          <Input
            label="Ciudad"
            name="city"
            errors={errors}
            required
            minLength={3}
            maxLength={255}
            placeholder="Montevideo"
            type="text"
          />
          <Input
            label="Estado/Departamento"
            name="state"
            errors={errors}
            minLength={3}
            maxLength={255}
            placeholder="Montevideo"
            type="text"
            required
          />
          <Select
            name="country"
            label="País"
            options={[
              { label: 'Selecciona un país', value: '' },
              ...countries.map((country) => ({
                value: country.value,
                label: `${country.flag} ${country.label}`,
              })),
            ]}
            required
            errors={errors}
          />
          <Button type="submit">Guardar</Button>
        </form>
      </CardContent>
    </Card>
  );
}
